var _rect, _ellipse, _ellipse2, _ellipse3, _circle, _polygon, _polygon2, _path, _circle2, _circle3, _circle4, _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "#F6F8FC"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 960,
    cy: 950,
    rx: 900,
    ry: 180,
    fill: "#B3E5FC",
    fillOpacity: 0.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 960,
    cy: 1000,
    rx: 1100,
    ry: 120,
    fill: "#40A7DE",
    fillOpacity: 0.25
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 960,
    cy: 1050,
    rx: 1300,
    ry: 80,
    fill: "#40A7DE",
    fillOpacity: 0.15
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1700,
    cy: 200,
    r: 60,
    fill: "#FFD600",
    fillOpacity: 0.7
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "300,950 400,800 500,950",
    fill: "#81C784"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "450,950 600,850 700,950",
    fill: "#388E3C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1000 Q400 950 800 1000 T1920 1000 V1080 H0 Z",
    fill: "#40A7DE",
    fillOpacity: 0.18
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 900,
    cy: 870,
    r: 8,
    fill: "#40A7DE",
    fillOpacity: 0.7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 950,
    cy: 920,
    r: 5,
    fill: "#40A7DE",
    fillOpacity: 0.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1100,
    cy: 880,
    r: 7,
    fill: "#40A7DE",
    fillOpacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "eelBody",
    cx: 0.5,
    cy: 0.5,
    r: 0.7
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#b2bfa3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#3a3a2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#222"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eelBelly",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#b2bfa3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#6b7b4b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M400 900 Q700 700 1200 900 Q1500 1000 1700 800",
    stroke: "url(#eelBody)",
    strokeWidth: 54,
    fill: "none",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 900 Q700 720 1200 900 Q1500 980 1700 800",
    stroke: "url(#eelBelly)",
    strokeWidth: 18,
    fill: "none",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1700,
    cy: 800,
    rx: 38,
    ry: 22,
    fill: "url(#eelBody)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1690,
    cy: 800,
    rx: 10,
    ry: 6,
    fill: "#b2bfa3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1710,
    cy: 795,
    rx: 3,
    ry: 3.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1708,
    cy: 795,
    rx: 1.5,
    ry: 1.5,
    fill: "#222"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1675,
    cy: 815,
    rx: 7,
    ry: 3,
    fill: "#6B7B4B",
    transform: "rotate(20 1675 815)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 400,
    cy: 900,
    rx: 18,
    ry: 10,
    fill: "url(#eelBody)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 390,
    cy: 900,
    rx: 8,
    ry: 4,
    fill: "#b2bfa3"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1500,
    cy: 870,
    r: 4,
    fill: "#222"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1450,
    cy: 880,
    r: 3,
    fill: "#222"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1400,
    cy: 890,
    r: 2.5,
    fill: "#222"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1350,
    cy: 900,
    r: 2.5,
    fill: "#222"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1300,
    cy: 910,
    r: 2.5,
    fill: "#222"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1250,
    cy: 920,
    r: 2.5,
    fill: "#222"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1200,
    cy: 930,
    r: 2.5,
    fill: "#222"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1150,
    cy: 940,
    r: 2.5,
    fill: "#222"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1100,
    cy: 950,
    r: 2.5,
    fill: "#222"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1050,
    cy: 940,
    r: 2.5,
    fill: "#222"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1000,
    cy: 930,
    r: 2.5,
    fill: "#222"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 950,
    cy: 920,
    r: 2.5,
    fill: "#222"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 900,
    cy: 910,
    r: 2.5,
    fill: "#222"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 850,
    cy: 900,
    r: 2.5,
    fill: "#222"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 890,
    r: 2.5,
    fill: "#222"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 750,
    cy: 880,
    r: 2.5,
    fill: "#222"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 700,
    cy: 870,
    r: 2.5,
    fill: "#222"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 800,
    width: 120,
    height: 120,
    rx: 24,
    fill: "#fff",
    stroke: "#222",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 816,
    width: 24,
    height: 24,
    rx: 5,
    fill: "none",
    stroke: "#222",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 816,
    width: 24,
    height: 24,
    rx: 5,
    fill: "none",
    stroke: "#222",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 880,
    width: 24,
    height: 24,
    rx: 5,
    fill: "none",
    stroke: "#222",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 848,
    width: 10,
    height: 10,
    fill: "#222"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 864,
    width: 10,
    height: 10,
    fill: "#222"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 880,
    width: 10,
    height: 10,
    fill: "#222"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 848,
    width: 10,
    height: 10,
    fill: "#222"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 880,
    width: 6,
    height: 6,
    fill: "#222"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 890,
    width: 6,
    height: 6,
    fill: "#222"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundLogin);
export default __webpack_public_path__ + "static/media/backgroundLogin.02c9ef21a83765f449033e6ff848cdce.svg";
export { ForwardRef as ReactComponent };